import constants from "../constants";
import successHandle from "../../utils/successHandle";
import errorHandle from "../../utils/errorHandle";

const {
  GET_ADS, GET_ADS_SUCCESS, GET_ADS_ERROR,
  ADD_AD, ADD_AD_SUCCESS, ADD_AD_ERROR,
  EDIT_AD, EDIT_AD_SUCCESS, EDIT_AD_ERROR,
  DELETE_AD, DELETE_AD_SUCCESS, DELETE_AD_ERROR
} = constants;

const initialState = { loading: false, ads: [], message: '', error: '' }

export const adsReducer = (state = initialState, action) => {
  const { type, ads, message, error } = action;
  switch (type) {
    case GET_ADS:
    case ADD_AD:
    case EDIT_AD:
    case DELETE_AD:
      return { ...state, loading: true, error: '', message: '' }

    case GET_ADS_SUCCESS:
      return { ...state, loading: false, ads }
    case ADD_AD_SUCCESS:
    case EDIT_AD_SUCCESS:
    case DELETE_AD_SUCCESS:
      return { ...state, loading: false, message: successHandle(message) }

    case GET_ADS_ERROR:
    case ADD_AD_ERROR:
    case EDIT_AD_ERROR:
    case DELETE_AD_ERROR:
      return { ...state, loading: false, error: errorHandle(error) }

    default:
      return state
  }
}
